import React, { useContext } from "react";
import { StoreContext } from "../store/Store";

export const PageSection = ({ children }) => {
  const [store] = useContext(StoreContext);

  const { dimensions } = store;
  return dimensions.vh ? (
    <div
      style={{
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        paddingBottom: 10,
        width: dimensions.vw - 10,
      }}
    >
      {children}
    </div>
  ) : null;
};
